/**
 * Overall number of cards shown in the section, sales and trade-ins combined.
 * Also drives the orderlines fetch size (see useSaleCards).
 */
export const MAX_VISIBLE_CARDS = 10

export const WEEKDAY_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
}

export function compareByDateDesc(
  a: { sortDate: Date | null },
  b: { sortDate: Date | null },
): number {
  const aTime = a.sortDate?.getTime() ?? Number.NEGATIVE_INFINITY
  const bTime = b.sortDate?.getTime() ?? Number.NEGATIVE_INFINITY

  return bTime - aTime
}
